// example return is "01-01-2024 01:01:01"
export const getDateTime = (time) => {
    const year = time.getFullYear().toString();
    let month = (time.getMonth() + 1).toString();
    let day = time.getDate().toString();
    let hour = time.getHours().toString();
    let minute = time.getMinutes().toString();
    let second = time.getSeconds().toString();
    if (month.toString().length === 1) {
        month = `0${month}`;
    }
    if (day.toString().length === 1) {
        day = `0${day}`;
    }
    if (hour.toString().length === 1) {
        hour = `0${hour}`;
    }
    if (minute.toString().length === 1) {
        minute = `0${minute}`;
    }
    if (second.toString().length === 1) {
        second = `0${second}`;
    }
    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
};
// example return is "GMT-0400"
export const getLocalTimeZone = (time) => {
    // eslint-disable-next-line no-useless-escape
    return time.toString().match(/([A-Z]+[\+-][0-9]+)/)[1];
};
